import { render } from "./overview_1.0.0.vue?vue&type=template&id=9ed5b300"
import script from "./overview_1.0.0.vue?vue&type=script&lang=ts"
export * from "./overview_1.0.0.vue?vue&type=script&lang=ts"
script.render = render

export default script